import React, { Component } from "react";
import { connect } from "react-redux";

import {
    fetchConfigurations,
    saveConfig,
    updateConfig,
    deleteConfig,

    setCurrentConfig,
    createConfiguration,
    updateConfigName,

    addField,
    updateField,
    deleteField,
    moveField,
    toggleField,

    addOption,
    updateOption,
    deleteOption,
    FIELD_TYPES
} from "../../Store/Slices/configSlice";

class ConfigManager extends Component {
    componentDidMount() {
        const {
            configurations,
            fetchConfigurations,
        } = this.props;

        if (!configurations?.length) {
            fetchConfigurations();
        }
    }

    handleSave = () => {
        const {
            config,
            saveConfig,
            updateConfig
        } = this.props;

        if (!config) {
            return;
        }

        if (config.id !== "new") {
            updateConfig(config);
        } else {
            saveConfig(config);
        }
    };

    handleDelete = () => {
        const {
            config,
            deleteConfig,
            setCurrentConfig
        } = this.props;

        if (!config) {
            return;
        }

        if (
            window.confirm(
                `Delete "${config.name}"?`
            )
        ) {
            deleteConfig(config.id);
        }
        setCurrentConfig(null);
    };

    handleCreate = () => {
        const {
            createConfiguration,
        } = this.props;

        createConfiguration();
    };

    renderField = (field, index) => {
        const {
            config,
            expandedFieldId,
            toggleField,
            moveField,
            updateField,
            deleteField,
            addOption,
            updateOption,
            deleteOption,
        } = this.props;

        const isExpanded =
            expandedFieldId === field.id;

            console.log(index,field)
        return (
            <div
                key={field.id}
                className="border rounded-lg mb-2 overflow-hidden"
            >
                {/* Compact field row */}

                <div
                    className="flex items-center gap-3 px-3 py-2 bg-white cursor-pointer"
                    onClick={() =>
                        toggleField(field.id)
                    }
                >
                    <span className="w-5 text-xs text-gray-400">
                        {field.index}
                    </span>

                    <div className="flex-1 min-w-0">
                        <div className="font-medium truncate">
                            {field.displayName ||
                                "Unnamed field"}
                        </div>

                        <div className="text-xs text-gray-400 truncate">
                            {field.keyName ||
                                "field_name"}
                        </div>
                    </div>

                    <span className="text-xs px-2 py-1 rounded bg-gray-100">
                        {field.keyType}
                    </span>

                    {field.isRequired && (
                        <span className="text-xs text-gray-400">
                            Required
                        </span>
                    )}

                    {/* Move up */}

                    <button
                        type="button"
                        disabled={index === 0}
                        onClick={(e) => {
                            e.stopPropagation();

                            moveField({
                                fieldId: field.id,
                                direction: "up",
                            });
                        }}
                        className="text-gray-400 hover:text-gray-700 disabled:opacity-20"
                    >
                        ↑
                    </button>

                    {/* Move down */}

                    <button
                        type="button"
                        disabled={
                            index ===
                            config.fields.length - 1
                        }
                        onClick={(e) => {
                            e.stopPropagation();

                            moveField({
                                fieldId: field.id,
                                direction: "down",
                            });
                        }}
                        className="text-gray-400 hover:text-gray-700 disabled:opacity-20"
                    >
                        ↓
                    </button>

                    <span className="w-4 text-gray-400">
                        {isExpanded ? "⌃" : "⌄"}
                    </span>
                </div>

                {/* Field editor */}

                {isExpanded && (
                    <div className="border-t bg-gray-50 p-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                            {/* Name */}

                            <div>
                                <label className="block text-xs text-gray-500 mb-1">
                                    Display Name
                                </label>

                                <input
                                    value={
                                        field.displayName ||
                                        ""
                                    }
                                    onChange={(e) =>
                                        updateField({
                                            fieldId:
                                                field.id,
                                            key: "displayName",
                                            value: e.target.value,
                                        })
                                    }
                                    placeholder="facebook_page_token"
                                    className="w-full border rounded px-2 py-1.5 bg-white"
                                />
                            </div>

                            {/* Display Name */}

                            <div>
                                <label className="block text-xs text-gray-500 mb-1">
                                    Key Name
                                </label>

                                <input
                                    value={
                                        field.keyName||
                                        ""
                                    }
                                    onChange={(e) =>
                                        updateField({
                                            fieldId:
                                                field.id,
                                            key: "keyName",
                                            value: e.target.value,
                                        })
                                    }
                                    placeholder="Facebook Page Token"
                                    className="w-full border rounded px-2 py-1.5 bg-white"
                                />
                            </div>

                            {/* Type */}

                            <div>
                                <label className="block text-xs text-gray-500 mb-1">
                                    Type
                                </label>

                                <select
                                    value={
                                        field.keyType ||
                                        0
                                    }
                                    onChange={(e) =>
                                        updateField({
                                            fieldId:
                                                field.id,
                                            key: "keyType",
                                            value: e.target.value,
                                        })
                                    }
                                    className="w-full border rounded px-2 py-1.5 bg-white"
                                >
                                    {FIELD_TYPES.map(
                                        (type) => (
                                            <option
                                                key={
                                                    type.value
                                                }
                                                value={
                                                    type.value
                                                }
                                            >
                                                {
                                                    type.label
                                                }
                                            </option>
                                        )
                                    )}
                                </select>
                            </div>

                            {/* Placeholder */}

                            <div>
                                <label className="block text-xs text-gray-500 mb-1">
                                    Placeholder
                                </label>

                                <input
                                    value={
                                        field.placeholder ||
                                        ""
                                    }
                                    onChange={(e) =>
                                        updateField({
                                            fieldId:
                                                field.id,
                                            key: "placeholder",
                                            value: e.target.value,
                                        })
                                    }
                                    placeholder="Enter value..."
                                    className="w-full border rounded px-2 py-1.5 bg-white"
                                />
                            </div>
                        </div>

                        {/* Required */}

                        <label className="flex items-center gap-2 mt-3 text-sm">
                            <input
                                type="checkbox"
                                checked={
                                    !!field.isRequired
                                }
                                onChange={(e) =>
                                    updateField({
                                        fieldId:
                                            field.id,
                                        key: "isRequired",
                                        value: e.target.checked,
                                    })
                                }
                            />

                            Required
                        </label>

                        {/* Description */}

                        <div className="mt-3">
                            <label className="block text-xs text-gray-500 mb-1">
                                Description
                            </label>

                            <textarea
                                value={
                                    field.description ||
                                    ""
                                }
                                onChange={(e) =>
                                    updateField({
                                        fieldId:
                                            field.id,
                                        key: "description",
                                        value: e.target.value,
                                    })
                                }
                                rows={2}
                                className="w-full border rounded px-2 py-1.5 bg-white"
                                placeholder="Explain what this configuration is used for..."
                            />
                        </div>

                        {/* Select options */}

                        {field.keyType === 7 && (
                            <div className="mt-4">
                                <div className="flex items-center justify-between mb-2">
                                    <span className="text-xs font-medium">
                                        Options
                                    </span>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            addOption(
                                                field.id
                                            )
                                        }
                                        className="text-xs border rounded px-2 py-1 bg-white"
                                    >
                                        + Option
                                    </button>
                                </div>

                                {(
                                    field.options ||
                                    []
                                ).map(
                                    (
                                        option,
                                        optionIndex
                                    ) => (
                                        <div
                                            key={
                                                optionIndex
                                            }
                                            className="flex gap-2 mb-2"
                                        >
                                            <input
                                                value={
                                                    option.key ||
                                                    ""
                                                }
                                                onChange={(
                                                    e
                                                ) =>
                                                    updateOption(
                                                        {
                                                            fieldId:
                                                                field.id,
                                                            optionIndex,
                                                            key: "key",
                                                            value: e.target.value,
                                                        }
                                                    )
                                                }
                                                placeholder="key"
                                                className="flex-1 border rounded px-2 py-1.5 bg-white"
                                            />

                                            <input
                                                value={
                                                    option.value ||
                                                    ""
                                                }
                                                onChange={(
                                                    e
                                                ) =>
                                                    updateOption(
                                                        {
                                                            fieldId:
                                                                field.id,
                                                            optionIndex,
                                                            key: "value",
                                                            value: e.target.value,
                                                        }
                                                    )
                                                }
                                                placeholder="Value"
                                                className="flex-1 border rounded px-2 py-1.5 bg-white"
                                            />

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    deleteOption(
                                                        {
                                                            fieldId:
                                                                field.id,
                                                            optionIndex,
                                                        }
                                                    )
                                                }
                                                className="px-2 text-red-500"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    )
                                )}
                            </div>
                        )}

                        {/* Delete field */}

                        <div className="mt-4 pt-3 border-t">
                            <button
                                type="button"
                                onClick={() =>
                                    deleteField(
                                        field.id
                                    )
                                }
                                className="text-sm text-red-600 hover:text-red-700"
                            >
                                Delete Field
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    renderConfigurationList() {
        const {
            configurations,
            loading,
            error,
            setCurrentConfig,
        } = this.props;

        return (
            <div className="w-full">

                {/* Header */}

                <div className="flex flex-wrap items-center justify-between gap-3 mb-6">

                    <div>
                        <h2 className="hk-display text-xl font-semibold">
                            Configurations
                        </h2>

                        <p className="text-sm text-gray-500 mt-1">
                            Manage reusable configuration
                            schemas.
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={
                            this.handleCreate
                        }
                        className="border rounded px-4 py-2 text-sm bg-white hover:bg-gray-50"
                    >
                        + New Configuration
                    </button>

                </div>

                {/* Error */}

                {error && (
                    <div className="mb-4 px-3 py-2 rounded bg-red-50 text-red-600 text-sm">
                        {error}
                    </div>
                )}

                {/* Loading */}

                {loading && (
                    <div className="p-6 text-center text-sm text-gray-400">
                        Loading configurations...
                    </div>
                )}

                {/* Configuration table */}

                {!loading &&
                    configurations?.length > 0 && (
                        <div className="border rounded-lg overflow-hidden bg-white">

                            {/* Table header — desktop only; rows stack on mobile */}

                            <div className="hidden md:grid grid-cols-12 gap-4 px-4 py-2 border-b bg-gray-50 text-xs font-medium text-gray-500">

                                <div className="col-span-5">
                                    Configuration
                                </div>

                                <div className="col-span-2">
                                    Version
                                </div>

                                <div className="col-span-2">
                                    Fields
                                </div>

                                <div className="col-span-2">
                                    Packages
                                </div>

                                <div className="col-span-1">
                                </div>

                            </div>

                            {/* Rows */}

                            {configurations.map(
                                (
                                    item,
                                    index
                                ) => {

                                    const fieldCount =
                                        (
                                            item.fields ||
                                            []
                                        ).length;

                                    const packageCount =
                                        item.packageCount ??
                                        item.packagesCount ??
                                        (
                                            item.packages ||
                                            []
                                        ).length;

                                    return (
                                        <div
                                            key={
                                                item.id
                                            }
                                            className={`grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 items-center px-4 py-4 hover:bg-gray-50 ${index <
                                                    configurations.length -
                                                    1
                                                    ? "border-b"
                                                    : ""
                                                }`}
                                        >

                                            {/* Configuration */}

                                            <div className="col-span-2 md:col-span-5 min-w-0">

                                                <div className="font-medium truncate">
                                                    {item.name ||
                                                        "Unnamed configuration"}
                                                </div>

                                                {item.description && (
                                                    <div className="text-xs text-gray-400 mt-1 truncate">
                                                        {
                                                            item.description
                                                        }
                                                    </div>
                                                )}

                                            </div>

                                            {/* Version */}

                                            <div className="col-span-1 md:col-span-2 text-sm text-gray-600">
                                                v
                                                {item.version}.{item.subVersion}
                                            </div>

                                            {/* Fields */}

                                            <div className="col-span-1 md:col-span-2 text-sm text-gray-600">
                                                {
                                                    fieldCount
                                                }
                                                <span className="text-xs text-gray-400 ml-1">
                                                    field
                                                    {fieldCount !==
                                                        1
                                                        ? "s"
                                                        : ""}
                                                </span>
                                            </div>

                                            {/* Packages */}

                                            <div className="col-span-1 md:col-span-2 text-sm text-gray-600">
                                                {
                                                    packageCount
                                                }
                                                <span className="text-xs text-gray-400 ml-1">
                                                    package
                                                    {packageCount !==
                                                        1
                                                        ? "s"
                                                        : ""}
                                                </span>
                                            </div>

                                            {/* Edit */}

                                            <div className="col-span-1 md:col-span-1 flex justify-end">

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setCurrentConfig(
                                                            item.id
                                                        )
                                                    }
                                                    className="border rounded px-3 py-1.5 text-sm bg-white hover:bg-gray-100"
                                                >
                                                    Edit
                                                </button>

                                            </div>

                                        </div>
                                    );
                                }
                            )}

                        </div>
                    )}

                {/* Empty state */}

                {!loading &&
                    !configurations?.length && (
                        <div className="border border-dashed rounded-lg py-12 text-center">

                            <div className="text-sm text-gray-500">
                                No configurations yet.
                            </div>

                            <button
                                type="button"
                                onClick={
                                    this.handleCreate
                                }
                                className="mt-3 border rounded px-3 py-2 text-sm bg-white hover:bg-gray-50"
                            >
                                + Create Configuration
                            </button>

                        </div>
                    )}

            </div>
        );
    }

    renderConfigurationEditor() {
        const {
            configurations,
            currentConfigId,
            config,
            loading,
            saving,
            error,

            setCurrentConfig,
            updateConfigName,
            addField,
        } = this.props;

        if (loading && !config) {
            return (
                <div className="p-6 text-gray-500">
                    Loading configuration...
                </div>
            );
        }

        if (!config) {
            return (
                <div className="p-6 text-gray-500">
                    No configuration selected.
                </div>
            );
        }

        return (
            <div className="w-full">

                {/* Header */}

                <div className="flex flex-wrap items-center justify-between gap-3 mb-5">

                    <div className="flex flex-wrap items-center gap-3">

                        {/* Back */}

                        <button
                            type="button"
                            onClick={() =>
                                setCurrentConfig(null)
                            }
                            className="text-sm text-gray-500 hover:text-gray-900"
                        >
                            ← Configurations
                        </button>

                        <span className="text-gray-300">
                            /
                        </span>

                        {/* Configuration selector */}

                        <select
                            value={
                                currentConfigId ||
                                ""
                            }
                            onChange={(e) =>
                                setCurrentConfig(
                                    e.target.value
                                )
                            }
                            className="border rounded px-3 py-2 font-medium bg-white"
                        >
                            {configurations.map(
                                (item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name ||
                                            "Unnamed configuration"}
                                    </option>
                                )
                            )}
                        </select>

                        <span className="text-xs text-gray-400">
                            v
                            {config.version ||
                                1}
                        </span>

                    </div>

                    <button
                        type="button"
                        onClick={
                            this.handleCreate
                        }
                        className="border rounded px-3 py-2 text-sm bg-white hover:bg-gray-50"
                    >
                        + New
                    </button>

                </div>

                {/* Error */}

                {error && (
                    <div className="mb-4 px-3 py-2 rounded bg-red-50 text-red-600 text-sm">
                        {error}
                    </div>
                )}

                {/* Configuration information */}

                <div className="border rounded-lg bg-white p-4 mb-4">

                    <div className="flex items-end gap-4">

                        <div className="flex-1">

                            <label className="block text-xs text-gray-500 mb-1">
                                Configuration Name
                            </label>

                            <input
                                value={
                                    config.name ||
                                    ""
                                }
                                onChange={(e) =>
                                    updateConfigName(
                                        e.target.value
                                    )
                                }
                                placeholder="Configuration name"
                                className="w-full text-lg font-semibold border rounded px-3 py-2 bg-white focus:outline-none focus:border-black"
                            />

                        </div>

                        <div className="pb-2">

                            <span className="text-xs text-gray-400">
                                Version{" "}
                                {config.version}.{config.subVersion}
                            </span>

                        </div>

                    </div>

                </div>

                {/* Fields */}

                <div className="mb-3">

                    {config.fields.length === 0 ? (
                        <div className="border border-dashed rounded-lg py-8 text-center text-sm text-gray-400">
                            No configuration fields
                            yet.
                        </div>
                    ) : (
                        config.fields.map((f,i) => 
                            this.renderField(f,i)
                        )
                    )}

                </div>

                {/* Add field */}

                <button
                    type="button"
                    onClick={addField}
                    className="w-full border border-dashed rounded-lg py-3 text-sm text-gray-500 hover:text-gray-800 hover:border-gray-400"
                >
                    + Add Configuration Field
                </button>

                {/* Footer */}

                <div className="flex justify-between items-center mt-5 pt-4 border-t">

                    <button
                        type="button"
                        onClick={
                            this.handleDelete
                        }
                        className="text-sm text-red-600 hover:text-red-700"
                    >
                        Delete Configuration
                    </button>

                    <button
                        type="button"
                        onClick={
                            this.handleSave
                        }
                        disabled={
                            saving ||
                            !config.name?.trim()
                        }
                        className="px-5 py-2 rounded bg-black text-white text-sm disabled:opacity-50"
                    >
                        {saving
                            ? "Saving..."
                            : config.id !== "new" ? "Update" : "Create"}
                    </button>

                </div>

            </div>
        );
    }

    render() {
        const {
            currentConfigId,
        } = this.props;

        /*
         * Important:
         *
         * No configuration is selected by default.
         * The configuration list is therefore the
         * default view.
         */

        if (!currentConfigId) {
            return this.renderConfigurationList();
        }

        return this.renderConfigurationEditor();
    }
}

const mapStateToProps = (state) => ({
    configurations: state.config.configurations,
    currentConfigId:state.config.currentConfigId,
    config: state.config.currentConfig,
    expandedFieldId:state.config.expandedFieldId,
    loading:state.config.loading,
    saving:state.config.saving,
    error:state.config.error,
});

const mapDispatchToProps = {
    fetchConfigurations,
    saveConfig,
    updateConfig,
    deleteConfig,

    setCurrentConfig,
    createConfiguration,
    updateConfigName,

    addField,
    updateField,
    deleteField,
    moveField,
    toggleField,

    addOption,
    updateOption,
    deleteOption,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfigManager);